<style lang="scss">
img {
    vertical-align: middle;
    height: 20px;
}
.line-24 {
    line-height: 24px;
}
.base-title {
    line-height: 36px;
    border-bottom: 1px solid #dedede;
    margin-bottom: 16px;
    padding-left: 20px;
    background-color: #2d8cf0;
    color: #fff;
}
</style>
<style lang="scss" scoped>
.color-label {
    max-width: 55px;
    word-break: break-all;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #fff;
    padding: 0 5px;
    margin-right: 5px;
}
</style>
<template>
    <div class="bg-fff shadow">
        <header class="base-title font-bold">
            {{
                $t("global.common.base_information", {
                    defaultValue: "基本信息",
                })
            }}
        </header>
        <Form :label-width="120" ref="form" class="margin-15 clearfix">
            <Col span="24">
                <Col span="12">
                    <FormItem
                        :label="
                            $t('erp.b2c.search_ordernumber', {
                                defaultValue: '订单号',
                            })
                        "
                    >
                        <span class="font-weight"
                            >{{ combaseInfo.orderId }} /
                            {{ combaseInfo.orderNo }}</span
                        >
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('erp.b2c.search_ordertype', {
                                defaultValue: '订单类型',
                            })
                        "
                    >
                        <div
                            style="
                                width: 65px;
                                display: inline-block;
                                vertical-align: middle;
                            "
                            v-html="orderTypes[combaseInfo.orderType]"
                        ></div>

                        <img
                            class="margin-right-5"
                            v-show="combaseInfo.isCelebrity == 'Y'"
                            src="/picture/hongren.png"
                        />
                        <img
                            class="margin-right-5"
                            v-show="combaseInfo.isSample == 'Y'"
                            src="/picture/yangpin.png"
                        />
                        <img
                            class="margin-right-5"
                            v-show="combaseInfo.isReshipment == 'Y'"
                            src="/picture/bufa.png"
                        />
                        <img
                            class="margin-right-5"
                            v-show="combaseInfo.isAddition == 'Y'"
                            src="/picture/lipin.png"
                        />
                        <img
                            class="margin-right-5"
                            v-show="
                                combaseInfo.isDismantlement == 'Y' &&
                                combaseInfo.parentId == 0
                            "
                            src="/picture/chaifu.png"
                        />
                        <img
                            class="margin-right-5"
                            v-show="
                                combaseInfo.isDismantlement == 'Y' &&
                                combaseInfo.parentId != 0
                            "
                            src="/picture/chaizi.png"
                        />
                        <span
                            v-show="combaseInfo.isPrime == 'Y'"
                            class="b2cfont-italic b2ccolor-info"
                            >Prime</span
                        >
                        <span
                            v-show="combaseInfo.isOnsite == 'Y'"
                            class="b2cfont-italic b2ccolor-content"
                            >Onsite</span
                        >
                        <span
                            v-show="combaseInfo.isBusinessOrder == 'Y'"
                            class="b2cfont-italic b2ccolor-error"
                            >Business</span
                        >
                        <span
                            v-show="combaseInfo.shipmentType == 1"
                            class="b2cfont-italic b2ccolor-warning"
                            >Store</span
                        >
                        <div
                            style="
                                display: inline-flex;
                                vertical-align: middle;
                                margin-left: 5px;
                            "
                        >
                            <div
                                v-for="item in selectedList"
                                :key="item.labelId"
                            >
                                <Tooltip :content="item.labelName">
                                    <div
                                        :class="`color-label color-${item.labelColour}`"
                                    >
                                        {{ item.labelName }}
                                    </div>
                                </Tooltip>
                            </div>
                        </div>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('erp.b2c.channel_account', {
                                defaultValue: '渠道账号',
                            })
                        "
                    >
                        <span class="font-weight">{{
                            this.channel.label || combaseInfo.channelFlag
                        }}</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('erp.b2c.delivery_type', {
                                defaultValue: '发货类型',
                            })
                        "
                    >
                        <span class="font-weight">{{
                            combaseInfo.fulfillmentChannel
                        }}</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('global.common.createdtime', {
                                defaultValue: '创建时间',
                            })
                        "
                    >
                        <span class="font-weight">{{
                            combaseInfo.channelCreated
                        }}</span>
                    </FormItem>
                </Col>

                <Col
                    span="12"
                    v-if="b2cPriceInfo == true"
                >
                    <FormItem
                        :label="
                            $t('erp.b2c.sales_amount', {
                                defaultValue: '销售金额',
                            })
                        "
                    >
                        <span class="font-weight"
                            >{{ combaseInfo.amount }}
                            {{ combaseInfo.currencyCode }}</span
                        >
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('erp.b2c.search_orderstatus', {
                                defaultValue: '订单状态',
                            })
                        "
                    >
                        <span class="font-weight"
                            ><div
                                v-html="orderStatus[combaseInfo.orderStatus]"
                            ></div
                        ></span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('erop.b2c.pruchase_orderno', {
                                defaultValue: 'Po Number',
                            })
                        "
                    >
                        <span class="font-weight">{{
                            combaseInfo.poNumber || "--"
                        }}</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('erp.b2c.customers_email', {
                                defaultValue: '客户邮箱',
                            })
                        "
                    >
                        <span class="font-weight">{{
                            combaseInfo.buyEmail || "--"
                        }}</span>
                    </FormItem>
                </Col>
            </Col>
        </Form>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
    props: [
        "combaseInfo",
        "type",
        "status",
        "parentId",
        "labelData",
        "selectedLabel",
    ],
    data() {
        return {
            orgId: global.SYSID,
            channel: "",
            orderTypes: {
                normally:
                    '<div class="b2ccolor-dark-primary font-weight span-padding line-24">' +
                    this.$t("erp.b2c.ordertype_normally", {
                        defaultValue: "正常销售",
                    }) +
                    "</div>",
                celebrity:
                    '<div class="b2ccolor-error font-weight span-padding line-24">' +
                    this.$t("erp.b2c.ordertype_celebrity", {
                        defaultValue: "展示订单",
                    }) +
                    "</div>",
                distribution:
                    '<div class="b2ccolor-success font-weight span-padding line-24">' +
                    this.$t("erp.b2c.ordertype_distribution", {
                        defaultValue: "分销订单",
                    }) +
                    "</div>",
                brush:
                    '<div class="b2ccolor-warning font-weight span-padding line-24">' +
                    this.$t("erp.b2c.ordertype_brush", {
                        defaultValue: "刷评订单",
                    }) +
                    "</div>",
                DELIVERY:
                    '<div class="b2ccolor-warning font-weight span-padding line-24">' +
                    this.$t("erp.b2c.ordertype_delivery", {
                        defaultValue: "发货订单",
                    }) +
                    "</div>",
            },
            orderStatus: {
                pending:
                    '<div class="b2cspan-error span-padding line-24">' +
                    this.$t("erp.b2c.orderstatus_pending", {
                        defaultValue: "未支付",
                    }) +
                    "</div>",
                unshipped:
                    '<div class="b2cspan-middle-content span-padding line-24">' +
                    this.$t("erp.b2c.orderstatus_unshipped", {
                        defaultValue: "未发货",
                    }) +
                    "</div>",
                approved:
                    '<div class="b2cspan-success span-padding line-24">' +
                    this.$t("erp.b2c.orderstatus_approved", {
                        defaultValue: "已审核",
                    }) +
                    "</div>",
                assigned:
                    '<div class="b2cspan-primary span-padding line-24">' +
                    this.$t("erp.b2c.orderstatus_assigned", {
                        defaultValue: "已分配",
                    }) +
                    "</div>",
                picked:
                    '<div class="b2cspan-info span-padding line-24">' +
                    this.$t("erp.b2c.orderstatus_picked", {
                        defaultValue: "已配货",
                    }) +
                    "</div>",
                shipped:
                    '<div class="b2cspan-light-content span-padding line-24">' +
                    this.$t("erp.b2c.orderstatus_shipped", {
                        defaultValue: "已发货",
                    }) +
                    "</div>",
                canceled:
                    '<div class="b2cspan-warning span-padding line-24">' +
                    this.$t("erp.b2c.orderstatus_canceled", {
                        defaultValue: "已取消",
                    }) +
                    "</div>",
                refunded:
                    '<div class="b2cspan-dark-primary span-padding line-24">' +
                    this.$t("erp.b2c.orderstatus_refunded", {
                        defaultValue: "已退款",
                    }) +
                    "</div>",
            },
            b2cPriceInfo: false,
            labelList: [],
            selectedList: [],
        };
    },
    watch: {
        combaseInfo: {
            deep: true,
            handler(val) {
                this.channel =
                    this.getNewAccountIdList.filter((item) => {
                        return val.channelFlag == item.attach.item.flag;
                    })[0] || {};
            },
        },
        selectedLabel: {
            handler(val) {
                // if (!val || !val.length) return;
                this.selectedList = val;
            },
        },
    },
    created() {
        this.b2cPriceInfo = this.handleAuth("erp.b2cOrder.indexPrice");
    },
    computed: {
        // ...mapState('boss',['products']),
        // ...mapGetters('boss',['warehouses']),
        ...mapGetters("diction", ["getNewAccountIdList"]),
    },
    methods: {},
    filters: {
        filterFillChannel(val) {
            let type;
            switch (val) {
                case "0":
                    type = "MFN";
                    break;
                case "1":
                    type = "AFM";
                    break;
            }
            return type;
        },
    },
};
</script>
